export default {"src":"/_next/static/media/wandelen.471a4e31.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};